import '../../../utils/index.js';
import createContextUtilities from '../../../utils/createContextUtilities/createContextUtilities.js';

const {
  Provider: FormProvider,
  useContext: useFormContext
} = createContextUtilities({});

export { FormProvider, useFormContext };
